export interface IdentificationType {
  id: string;
  name: string;
  rules: unknown;
}

export interface IdentificationTypeResponse {
  identificationTypes: IdentificationType[];
}

export enum TeacherRoles {
  TUTOR = 'TTR',
  TEACHER = 'TCH',
  TEACHER_TUTOR = 'TCH_TTR',
}

export const teacherRolesOptions = [
  { value: TeacherRoles.TUTOR, label: 'Tutor' },
  { value: TeacherRoles.TEACHER, label: 'Docente' },
  { value: TeacherRoles.TEACHER_TUTOR, label: 'Docente - Tutor' },
];

export type TeacherRole = typeof TeacherRoles[keyof typeof TeacherRoles];
